var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"hero"}},[_c('video-background',{staticClass:"video",staticStyle:{"max-height":"100vh","height":"100vh","z-index":"1"},attrs:{"poster":require('@/assets/featured-1.png')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }